import { render, staticRenderFns } from "./mescroll-body.vue?vue&type=template&id=0eb50c53&filter-modules=eyJ3eHNCaXoiOnsidHlwZSI6InNjcmlwdCIsImNvbnRlbnQiOiIiLCJzdGFydCI6MzQ5NywiYXR0cnMiOnsic3JjIjoiLi93eHMvd3hzLnd4cyIsIm1vZHVsZSI6Ind4c0JpeiIsImxhbmciOiJ3eHMifSwiZW5kIjozNDk3fSwicmVuZGVyQml6Ijp7InR5cGUiOiJyZW5kZXJqcyIsImNvbnRlbnQiOiIiLCJzdGFydCI6MzYyNSwiYXR0cnMiOnsibW9kdWxlIjoicmVuZGVyQml6IiwibGFuZyI6ImpzIn0sImVuZCI6MzcwOX19&"
import script from "./mescroll-body.vue?vue&type=script&lang=js&"
export * from "./mescroll-body.vue?vue&type=script&lang=js&"
import style0 from "./mescroll-body.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./wxs/wxs.wxs?vue&type=custom&index=0&blockType=script&issuerPath=%2FUsers%2Ftudyzhb%2Fpure%2Fsrc%2Fgit.yichui.net%2Fyichui1%2Funi-contrib%2Fsrc%2Fcomponents%2Fmescroll-uni%2Fmescroll-body.vue&module=wxsBiz&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "src/components/mescroll-uni/mescroll-body.vue"
export default component.exports